import { notification } from "antd";

export const showOperationSummary = (results, t, operationDisplayNames = {}) => {
  const successfulOps = [];
  const failedOps = [];
  const partialOps = [];

  Object.entries(results).forEach(([operation, result]) => {
    if (!result.attempted) return;

    if (result.success && !result.error) {
      successfulOps.push(operation);
    } else if (result.success && result.error) {
      partialOps.push({ operation, error: result.error });
    } else {
      failedOps.push({ operation, error: result.error });
    }
  });

  const hasFailures = failedOps.length > 0;
  const hasPartial = partialOps.length > 0;

  const title = hasFailures
    ? getNotificationTitle(t, "partial")
    : hasPartial
      ? getNotificationTitle(t, "warning")
      : getNotificationTitle(t, "complete");

  const content = (
    <div>
      {successfulOps.length > 0 && (
        <div style={{ marginBottom: "8px" }}>
          <strong style={{ color: "#52c41a" }}>{t("successful_operations")}:</strong>
          <ul style={{ margin: "4px 0", paddingLeft: "20px" }}>
            {successfulOps.map((op) => (
              <li key={op}>{getOperationDisplayName(op, t, operationDisplayNames)}</li>
            ))}
          </ul>
        </div>
      )}

      {partialOps.length > 0 && (
        <div style={{ marginBottom: "8px" }}>
          <strong style={{ color: "#faad14" }}>{t("partial_operations")}:</strong>
          <ul style={{ margin: "4px 0", paddingLeft: "20px" }}>
            {partialOps.map(({ operation, error }) => (
              <li key={operation}>
                {getOperationDisplayName(operation, t, operationDisplayNames)}: {error}
              </li>
            ))}
          </ul>
        </div>
      )}

      {failedOps.length > 0 && (
        <div>
          <strong style={{ color: "#ff4d4f" }}>{t("failed_operations")}:</strong>
          <ul style={{ margin: "4px 0", paddingLeft: "20px" }}>
            {failedOps.map(({ operation, error }) => (
              <li key={operation}>
                {getOperationDisplayName(operation, t, operationDisplayNames)}: {error}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );

  notification.destroy();

  notification[hasFailures ? "error" : hasPartial ? "warning" : "success"]({
    message: title,
    description: content,
    duration: 0,
    style: { width: "400px" },
  });
};

const getOperationDisplayName = (operation, t, customNames = {}) => {
  // Use custom names first, then fall back to defaults
  if (customNames[operation]) {
    return customNames[operation];
  }

  // Default operation names
  const defaultNames = {
    firestore: t("notifications.database_updated"),
    exact: t("notifications.exact_updated"),
    stock: t("notifications.stock_updated"),
    sooCool: t("notifications.soocool_updated"),
    whatsapp: t("notifications.whatsapp_message_sent"),
    email: t("notifications.email_sent"),
    discountCode: t("notifications.discount_code_processed"),
  };

  return defaultNames[operation] || operation;
};

const getNotificationTitle = (t, type) => {
  const titleMappings = {
    partial: t("notifications.operation_partially_completed"),
    warning: t("notifications.operation_completed_with_warnings"),
    complete: t("notifications.operation_completed_successfully"),
  };

  return titleMappings[type];
};
